function ItemQuantity({ quantity = 1, onChange }) {
  const handleQuantityChange = (newQuantity) => {
    // Ensure quantity is not less than 1
    if (newQuantity < 1) return;

    onChange(newQuantity);
  };

  return (
    <div className="flex items-center gap-2 mt-2">
      <button
        type="button"
        onClick={() => handleQuantityChange(quantity - 1)}
        className="p-1 rounded-full hover:bg-gray-100 disabled:opacity-50"
        disabled={quantity <= 1}
      >
        <svg className="w-5 h-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
        </svg>
      </button>

      <span className="w-8 text-center font-medium">
        {quantity}
      </span>

      <button
        type="button"
        onClick={() => handleQuantityChange(quantity + 1)}
        className="p-1 rounded-full hover:bg-gray-100"
      >
        <svg className="w-5 h-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
        </svg>
      </button>
    </div>
  );
}

export default ItemQuantity;
